import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import "../node_modules/fnon/fnon.min.css";
import LoadingSpinner from "./components/LoadingSpinner";
import RecoilNexus from "recoil-nexus";

// import LoginPage from "./pages/LoginPage";
// import ResetPage from "./pages/ResetPage";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

//load settings
root.render(
  <RecoilRoot>
    <RecoilNexus />
    <BrowserRouter basename={baseUrl}>
      <App />
      {/* <LoginPage /> */}
      {/* <ResetPage /> */}
    </BrowserRouter>
  </RecoilRoot>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
